module.exports = __webpack_public_path__ + "f82a3195ddf1cef2c3c7235c31ab425a.mp4";